<template>
	<div class="card border-0 card-with-shadow">
		<div class="card-header bg-transparent p-primary d-flex justify-content-between align-items-center">

			<h5 v-show="isDetailsActive" class="card-title text-muted mb-0">{{ $t('renewe_details') }}</h5>
			<h5 v-show="!isDetailsActive" class="card-title text-muted mb-0">{{ $t('renewe_edit_details') }}</h5>

			<div>
				<a v-show="!isDetailsActive" class="text-muted" href="#" @click.prevent="detailsInfoClose">
					<app-icon name="x-square" stroke-width="1"/>
				</a>
				<a v-show="!isDetailsActive" class="text-muted" href="#" @click.prevent="detailsInfoSync">
					<app-icon name="check-square" stroke-width="1"/>
				</a>
				<a v-show="isDetailsActive" class="text-muted" href="#" @click.prevent="detailsInfoEdit">
					<app-icon name="edit" stroke-width="1"/>
				</a>
			</div>

		</div>
		<div class="card-body">

			<div v-show="isDetailsActive">
                <div class="form-group mb-3">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('status') }}
						</label>
						<div class="col-7">
							<template v-if="detailsData.status">
                                <span :class="'badge badge '+statusClass+' badge-pill mr-2'">{{statusName}}</span>
							</template>
							<template v-else>
								-
							</template>
						</div>
					</div>
				</div>
                <div class="form-group mb-3">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('fund') }}
						</label>
						<div class="col-7">
							<template v-if="detailsData.fund">
                                <a :href="'/crm/funds/' + detailsData.fund.id + '/edit'" target="_blank">{{ detailsData.fund.name }}</a>
							</template>
							<template v-else>
								-
							</template>
						</div>
					</div>
				</div>
                <div class="form-group mb-3">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('person_res') }}
						</label>
						<div class="col-7">
							<template v-if="detailsData.person">
                                <a :href="'/crm/persons/' + detailsData.person.id + '/edit'" target="_blank">{{ detailsData.person.name }}</a>
							</template>
							<template v-else>
								-
							</template>
						</div>
					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('date_on') }}
						</label>
						<div class="col-7">
							<template v-if="detailsData.date_on">
								{{ formatDateToLocal(detailsData.date_on) }}
							</template>
							<template v-else>
								-
							</template>
						</div>
					</div>
				</div>		
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('date_off') }}
						</label>
						<div class="col-7">
							<template v-if="detailsData.date_off">
								{{ formatDateToLocal(detailsData.date_off) }}
							</template>
							<template v-else>
								-
							</template>
						</div>
					</div>
				</div>		
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('price') }}
						</label>
						<div class="col-7">
							<template v-if="detailsData.price">
								{{ detailsData.price }} {{symbol}}
							</template>
							<template v-else>
								-
							</template>
						</div>
					</div>
				</div>		
			</div>

			<div v-show="!isDetailsActive">
                <div class="form-group mb-3">
					<div class="form-row">
					<label class="col-5 mb-0 d-flex align-items-center">{{ $t('status') }}</label>
						<div class="col-7">
							<app-input v-model="detailsData.status"
							           :error-message="$errorMessage(errors, 'status')"
							           :list="statusList"
							           list-value-field='name'
										    :placeholder="$t('choose_status')"
							           type="select"/>
							</div>
					</div>
				</div>
                <div class="form-group mb-3">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('fund') }}
						</label>
						<div class="col-7">
							<template v-if="detailsData.fund">
                                <span>{{ detailsData.fund.name }}</span>
							</template>
							<template v-else>
								-
							</template>
						</div>
					</div>
				</div>
                <div class="form-group mb-3">
					<div class="form-row">
					<label class="col-5 mb-0 d-flex align-items-center">{{ $t('person_res') }}</label>
						<div class="col-7">
							<app-input v-model="detailsData.person_id"
							           :error-message="$errorMessage(errors, 'rest')"
							           :list="peopleList"
							           list-value-field='name'
										    :placeholder="$t('choose_who')"
							           type="search-select"/>
							</div>
					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('date_on') }}</label>
						<div class="col-7">
							<app-input
                				v-model="detailsData.date_on"
                				:placeholder="$t('choose_a_date')"
								:popover-position="'top-start'"
								type="date"
              				/>
						</div>
					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('date_off') }}</label>
						<div class="col-7">
							<app-input
                				v-model="detailsData.date_off"
                				:placeholder="$t('choose_a_date')"
								:popover-position="'top-start'"
								type="date"
              				/>
						</div>
					</div>
				</div>

				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('price') }}</label>
						<div class="col-4">
							<app-input v-model="detailsData.price"
							           :error-message="$errorMessage(errors, 'price')"
										   :placeholder="$t('enter_price')"
							           type="text"/>
						</div>
                        <div class="col-1"></div>
						<div class="col-2">
							<app-input v-model="detailsData.price_symbol"
							           :error-message="$errorMessage(errors, 'symbol')"
							           :list="symbolList"
							           list-value-field='name'
										    :placeholder="$t('choose_symbol')"
							           type="select"/>
						</div>
					</div>
				</div>

			
		
				
				
										 


			</div>

		</div>
	</div>
</template>

<script>

import {FormMixin} from "@core/mixins/form/FormMixin.js";
import {formatDateToLocal, urlGenerator} from "@app/Helpers/helpers";

export default {
	name: "DetailsInformationFund",
	mixins: [FormMixin],
	props: {
		detailsData: {
			type: Object,
			required: true
		},
		detailsSyncUrl: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			urlGenerator,
			formatDateToLocal,
			isDetailsActive: true,
			formData: {},
			statusList: [
                {
                    id: 1,
                    name: this.$t('status_renewe_process'),
                },
                {
                    id: 2,
                    name: this.$t('status_renewe_done'),
                },
            ],
			symbolList: [
                {
                    id: 1,
                    name: '₴',
                },
                {
                    id: 2,
                    name: '$',
                },
            ],
			countryList: [],
			status: [
	  		 	{ id: "1", name: "Собственник",},
				{ id: "2", name: "Аренда",},

	  		],
			errors: {}
		}
	},
	computed: {
		
        statusClass(){
            let status = (this.detailsData.status == 1) ? "badge-danger" : "badge-success";
            return status;
        },
        statusName(){
            let status = (this.detailsData.status == 1) ? this.$t('status_renewe_process') : this.$t('status_renewe_done');
            return status;
        },
        symbol(){
            let symbol = (this.detailsData.price_symbol == 1) ? "₴" : "$";
            return symbol;
        },
		peopleList() {
			return this.$store.getters.getPersonRe
		},
	},
	methods: {
		detailsInfoSync() {
            this.formData.status = this.detailsData.status;
            this.formData.fund_id = this.detailsData.fund_id;
            this.formData.person_id = this.detailsData.person_id;
            this.formData.price = this.detailsData.price;
            this.formData.price_symbol = this.detailsData.price_symbol;
            this.formData.date_on = this.detailsData.date_on ? moment(this.detailsData.date_on).format(
                "YYYY-MM-DD"
            ) : null;
            this.formData.date_off = this.detailsData.date_off ? moment(this.detailsData.date_off).format(
                "YYYY-MM-DD"
            ) : null;
			this.submitFromFixin('patch', this.detailsSyncUrl, this.formData);
		},

		afterError(response) {
			this.errors = response.data.errors
		},

		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.isDetailsActive = true
			this.errors = {}
			this.$emit('update-request');
		},

		detailsInfoClose() {
			this.isDetailsActive = true;
		},
		detailsInfoEdit() {
			this.isDetailsActive = false
		},

		
	},
	created() {
		
		
		
		
		this.$store.dispatch('getPersonRe');
		
	},
}
</script>

